import { createContext, useContext, useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import jwt_decode from "jwt-decode";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [cookies] = useCookies();
  const [apiToken, setApiToken] = useState(cookies.api_token);
  const [user, setUser] = useState(null);
  const [operator, setOperator] = useState(false);
  const [delegate, setDelegate] = useState(false);
  const [citizen, setCitizen] = useState(false);

  useEffect(() => {
    if (cookies.api_token) {
      setApiToken(cookies.api_token);
      const decoded = jwt_decode(cookies.api_token);
      setUser(decoded.FullName);

      if (decoded.role.includes("OPERATOR")) setOperator(true);
      if (decoded.role.includes("DELEGATE")) setDelegate(true);
      if (decoded.role.includes("CITIZEN")) setCitizen(true);
    }
  }, [cookies]);

  return (
    <UserContext.Provider value={{  user, operator, delegate, citizen,apiToken }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);